import React, { useEffect, useState } from 'react';
import { Calendar } from 'lucide-react';
export function StickyButton() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show button after scrolling past the hero section (approx 500px)
      setIsVisible(window.scrollY > 500);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-6 right-6 z-40 animate-fade-in-up" data-id="element-211">
      <a href="#courses" className="flex items-center gap-2 bg-peony-500 text-white px-6 py-4 rounded-full shadow-[0_0_20px_rgba(232,114,138,0.6)] hover:bg-peony-600 hover:scale-105 transition-all duration-300 animate-pulse-glow" data-id="element-212">
        <Calendar className="w-5 h-5" data-id="element-213" />
        <span className="font-semibold" data-id="element-214">Probetraining sichern</span>
      </a>
    </div>;
}